import { Check } from 'lucide-react'
import { labelForDisplayType } from '../../constants/displayTypes'
import styles from './SurfacePicker.module.css'

/**
 * Presentational surface chip picker.
 *
 * selectedIds is the resolved selected array. Callers that support "default"
 * semantics should resolve null/defaults before rendering and decide whether
 * to persist omitted keys or explicit arrays.
 */
export default function SurfacePicker({
  surfaces = [],
  selectedIds = [],
  onToggle,
  testId = 'publish-to-chips',
}) {
  return (
    <div className={styles.chipGroup} data-testid={testId}>
      {surfaces.map((surface) => {
        const checked = selectedIds.includes(surface.id)
        return (
          <button
            key={surface.id}
            type="button"
            role="checkbox"
            aria-checked={checked}
            onClick={() => onToggle(surface.id)}
            className={`${styles.chip} ${checked ? styles.chipOn : ''}`}
            data-testid={`publish-to-chip-${surface.slug}`}
            data-checked={checked ? 'true' : 'false'}
          >
            <span className={styles.chipCheckbox} aria-hidden>
              {checked ? <Check size={13} /> : null}
            </span>
            <span className={styles.chipLabel}>
              <strong>{surface.name}</strong>
              <em className={styles.chipSlug}>
                {surface.display_type ? `${surface.slug} · ${labelForDisplayType(surface.display_type)}` : surface.slug}
              </em>
            </span>
            {surface.include_by_default ? (
              <span className={styles.chipDefaultBadge}>Default</span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
